import {BaseApiTemplateService, Core2Config} from "../../../shared";
import {TemplateMessageContainerModel} from "../../../../../../../models/aggregates/alg/cc/template-message";
import {HttpClient} from "@angular/common/http";
import {Injectable} from "@angular/core";

@Injectable({providedIn: 'root'})
export class TemplateMessageService extends BaseApiTemplateService<TemplateMessageContainerModel>{
  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ALG_CC_MODULE + 'template-messages';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ALG_CC_MODULE + 'template-messages';
    this.httpClient = http;
  }
}
